 /**
 * Utility function to get configuration values from runtime or build-time environment
 * This allows for a "build once, deploy anywhere" approach
 * 
 * @param {string} key - The configuration key to retrieve (without VITE_ prefix)
 * @param {any} defaultValue - Optional default value if not found
 * @returns {string} The configuration value
 */
export function getRuntimeConfig(key, defaultValue = '') {
  // Check if runtime config exists and has the key
  if (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG[key]) {
    return window.RUNTIME_CONFIG[key];
  }
  
  // Fall back to import.meta.env if runtime config doesn't have the key
  if (import.meta.env[`${key}`]) {
    return import.meta.env[`${key}`];
  }
  
  // Return default value if neither source has the key
  return defaultValue;
}

export default getRuntimeConfig;
